import { doGet, toUrl } from "./lib.js";
import { integrationConfiguration } from "./schemas.js";
export async function fetchConfiguration(clientInfo) {
    const url = toUrl(clientInfo.orgId, "graph/configuration");
    const json = await doGet(url, clientInfo);
    const data = integrationConfiguration().parse(json.data);
    return { data };
}
